import styled from 'styled-components';
import { SidebarHeader } from '../../common/sidebar-right/sidebar.styles';
import { ServicesSubSectionHeader } from '../../features/services/services-subsection/services-subsection.styles';

export const DeliveryOptionCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 0.8rem;

  @media (max-width: 650px) {
    margin-top: 1.2rem;
  }
`;

export const ServicesSubSectionContainerForDelivery = styled.div`
  padding: 2.4rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  position: relative;
  border: 1px solid
    ${({ theme }) => theme.colors.passwordValidationMarker.backgroundColor};
  border-radius: 12px;

  ${SidebarHeader} > ${ServicesSubSectionHeader} {
    margin-bottom: 0;
  }

  ${ServicesSubSectionHeader} {
    margin-bottom: 0 !important;
  }

  @media screen and (max-width: 650px) {
    background-color: transparent;
    padding: 0 0.8rem;
    border: none;
    height: calc(100dvh - 110px - 95px);
    overflow-y: scroll;
    ${ServicesSubSectionHeader} {
      margin-bottom: 8px;
    }
    .icon-button-sorting {
      width: 44px;
    }
  }
`;

export const InfoButtonContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-top: -2px;
  cursor: pointer;

  svg {
    path {
      fill: ${({ theme }) => theme.colors.baseColors.grey80};
    }
  }
`;
